module.exports = {
	"data": {
		"2017": {
			"10": 571,
			"11": 843,
			"12": 1176
		},
		"2018": {
			"1": 1879,
			"2": 2753,
			"3": 3274,
			"4": 3704,
			"5": 4039,
			"6": 4348,
			"7": 4466,
			"8": 4564,
			"9": 4733,
			"10": 4845,
			"11": 4926,
			"12": 5033
		},
		"2019": {
			"1": 5246,
			"2": 5440,
			"3": 5573,
			"4": 5638,
			"5": 5931,
			"6": 6179,
			"7": 6543,
			"8": 6898,
			"9": 16646,
			"10": 17416,
			"11": 17524,
			"12": 17588
		},
		"2020": {
			"1": 17633,
			"2": 17703,
			"3": 17730,
			"4": 17779,
			"5": 17892,
			"6": 17920,
			"7": 17950,
			"8": 17972,
			"9": 18009,
			"10": 18037,
			"11": 18054,
			"12": 18066
		},
		"2021": {
			"1": 18128,
			"2": 18142,
			"3": 18151,
			"4": 18173,
			"5": 19210,
			"6": 21170,
			"7": 22419,
			"8": 22460,
			"9": 22491,
			"10": 22513,
			"11": 22564,
			"12": 22596
		},
		"2022": {
			"1": 22601
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Statistics/accessStats.json
 ** module id = 1566
 ** module chunks = 0
 **/